import React from 'react';
import { Button } from '../Button';
import { Parallax } from '../common/Parallax';
export function CtaBanner() {
  return <section className="relative w-full" data-id="element-122">
      <Parallax imageUrl="https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=2940&auto=format&fit=crop" // Subtle clean texture/surface
    className="w-full py-24 md:py-32" overlayClassName="bg-brand-navy/90" data-id="element-123">
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-124">
          <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-125">
            <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-brand-white mb-6 leading-tight" data-id="element-126">
              Ready for a Spotless Space?
            </h2>
            <p className="text-lg md:text-xl text-brand-sky mb-10 leading-relaxed" data-id="element-127">
              Get your free quote today and see the Deep Clean difference.
            </p>
            <Button className="bg-brand-aqua hover:bg-brand-aqua-dark text-white h-14 px-10 text-lg font-semibold rounded-full w-full sm:w-auto shadow-lg shadow-brand-aqua/20" data-id="element-128">
              Get a Free Quote
            </Button>
          </div>
        </div>
      </Parallax>
    </section>;
}